import { render, staticRenderFns } from "./Relence.vue?vue&type=template&id=0aa05cae&"
import script from "./Relence.vue?vue&type=script&lang=js&"
export * from "./Relence.vue?vue&type=script&lang=js&"
import style0 from "./Relence.vue?vue&type=style&index=0&id=0aa05cae&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports